// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".comment-form-area-module__formWithMargin--1HlHl{margin-bottom:40vh}.comment-form-area-module__buttonsWrapper--12h1u{margin-top:10px;display:flex;justify-content:center;gap:15px}.comment-form-area-module__buttonsWrapper--12h1u button{height:40px;flex:1}.comment-form-area-module__buttonsWrapper--12h1u .comment-form-area-module__primaryButton--36SXM{color:#fff}.comment-form-area-module__alert--4AegN{margin-top:20px}", ""]);
// Exports
exports.locals = {
	"formWithMargin": "comment-form-area-module__formWithMargin--1HlHl",
	"buttonsWrapper": "comment-form-area-module__buttonsWrapper--12h1u",
	"primaryButton": "comment-form-area-module__primaryButton--36SXM",
	"alert": "comment-form-area-module__alert--4AegN"
};
module.exports = exports;
